import { render } from "./ShieldListingButton.vue?vue&type=template&id=722b2b34"
import script from "./ShieldListingButton.vue?vue&type=script&lang=js"
export * from "./ShieldListingButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__